module.exports = __webpack_public_path__ + "static/img/建筑智能化_智能安防1@2x.9348f4f.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/buliding/建筑智能化_智能安防1@2x.jpeg
// module id = wwca
// module chunks = 1